import { useMemo, useState } from 'react';

export const OrderContextViewer = ({
  orderContext,
}: {
  orderContext: Record<string, unknown> | null | undefined;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const prettyJson = useMemo(() => {
    if (!orderContext) {
      return null;
    }
    try {
      return JSON.stringify(orderContext, null, 2);
    } catch {
      return String(orderContext);
    }
  }, [orderContext]);

  if (!orderContext || !prettyJson) {
    return null;
  }

  return (
    <div className="rounded-sm border border-slate-700/60 bg-slate-950/70 p-3">
      <button
        type="button"
        onClick={() => setIsExpanded((prev) => !prev)}
        className="flex w-full items-center justify-between text-sm font-medium text-slate-300"
      >
        <span>Orderkontext</span>
        <span className="text-xs uppercase tracking-wide text-slate-500">
          {isExpanded ? 'Dölj' : 'Visa'}
        </span>
      </button>
      {isExpanded ? (
        <pre className="mt-2 max-h-56 overflow-auto whitespace-pre-wrap break-words text-[11px] text-slate-400">
          {prettyJson}
        </pre>
      ) : null}
    </div>
  );
};
